export function addHoursToCurrentTime(hours) {
  const currentDate = new Date()
  const futureDate = currentDate.setTime(currentDate.getTime() + hours * 60 * 60 * 1000)
  return new Date(futureDate)
}
